import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NgSelectModule } from '@ng-select/ng-select';

export interface EnumFieldProps {
	multiple?: boolean;
	options?: { label: string; value: any; disabled?: boolean }[];
}

@Component({
	selector: 'formly-nebular-select',
	template: `
		<ng-select
			[items]="props.options"
			bindLabel="label"
			bindValue="value"
			[multiple]="!!props.multiple"
			[formControl]="formControl"
		></ng-select>
		@if (props.multiple) {
			<small class="form-text text-muted">Select multiple values</small>
		}
	`,
	imports: [ReactiveFormsModule, NgSelectModule]
})
export class FormlyNebularSelectTypeComponent extends FieldType<FieldTypeConfig<EnumFieldProps>> {}
